import { RoleName } from '../user/RoleName';
import { GuardRoleAffiliation } from './guardRoleAffiliation';

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GuardMasterDataManager extends GuardRoleAffiliation {
    protected getRoles(): RoleName[] {
        return [RoleName.MasterDataManager];
    }
}
